import { useEffect, useState } from 'react';
import { MailWarning } from 'lucide-react';
import { useSessao } from '../auth/SessaoContext';
import { api } from '../api/cliente';
import type { Precos } from '../api/tipos';
import { reais } from '../util/formato';
import { BotaoLink } from './ui';
import css from './AvisoVerificacao.module.css';

/**
 * Faixa fixa para quem ainda não confirmou o e-mail.
 *
 * O painel é navegável sem verificação — só as ações que consomem o provedor
 * externo ficam bloqueadas. Sem este aviso, a pessoa só descobriria isso ao
 * levar um 403 na cara ao tentar criar a primeira busca.
 */
export function AvisoVerificacao() {
  const { usuario } = useSessao();
  const [bonus, setBonus] = useState(0);
  const pendente = !!usuario && !usuario.emailVerificadoEm;

  useEffect(() => {
    if (!pendente) return;
    api<Precos>('/creditos/precos')
      .then((p) => setBonus(p.bonusCadastroCentavos))
      .catch(() => undefined);
  }, [pendente]);

  if (!usuario || usuario.emailVerificadoEm) return null;

  return (
    <div role="status" className={css.faixa}>
      <MailWarning className={css.icone} aria-hidden="true" />
      <span className={css.texto}>
        Confirme seu e-mail (<strong>{usuario.email}</strong>) para começar a baixar XMLs.
        {bonus > 0 ? (
          <>
            {' '}
            Você ganha <strong>{reais(bonus)} em créditos</strong> na hora.
          </>
        ) : (
          ' Até lá, novas buscas ficam bloqueadas.'
        )}
      </span>
      <BotaoLink to="/verificar-email" aparencia="secundario" pequeno>
        Inserir código
      </BotaoLink>
    </div>
  );
}
